import { FC } from 'react'

import { ISvgClass } from '../interface'

const ExitIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M9.8 16.275C9.6 16.075 9.504 15.8333 9.512 15.55C9.52067 15.2667 9.625 15.025 9.825 14.825L11.65 13H4C3.71667 13 3.47933 12.904 3.288 12.712C3.096 12.5207 3 12.2833 3 12C3 11.7167 3.096 11.479 3.288 11.287C3.47933 11.0957 3.71667 11 4 11H11.65L9.8 9.15C9.6 8.95 9.5 8.71267 9.5 8.438C9.5 8.16267 9.6 7.925 9.8 7.725C10 7.525 10.2377 7.425 10.513 7.425C10.7877 7.425 11.025 7.525 11.225 7.725L14.8 11.3C14.9 11.4 14.971 11.5083 15.013 11.625C15.0543 11.7417 15.075 11.8667 15.075 12C15.075 12.1333 15.0543 12.2583 15.013 12.375C14.971 12.4917 14.9 12.6 14.8 12.7L11.2 16.3C11.0167 16.4833 10.7877 16.575 10.513 16.575C10.2377 16.575 10 16.475 9.8 16.275ZM5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V16C3 15.7167 3.096 15.479 3.288 15.287C3.47933 15.0957 3.71667 15 4 15C4.28333 15 4.521 15.0957 4.713 15.287C4.90433 15.479 5 15.7167 5 16V19H19V5H5V8C5 8.28333 4.90433 8.52067 4.713 8.712C4.521 8.904 4.28333 9 4 9C3.71667 9 3.47933 8.904 3.288 8.712C3.096 8.52067 3 8.28333 3 8V5C3 4.45 3.19567 3.979 3.587 3.587C3.979 3.19567 4.45 3 5 3H19C19.55 3 20.021 3.19567 20.413 3.587C20.8043 3.979 21 4.45 21 5V19C21 19.55 20.8043 20.021 20.413 20.413C20.021 20.8043 19.55 21 19 21H5Z"
        fill="inherit"
      />
    </svg>
  )
}

export default ExitIcon
